// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".580.0.0." + {2239: "7f11463828049418",2733: "3c60ad4be151c950",2944: "f6fe2ceda5893e4b",5233: "92a719bec9f7a9ae",5338: "af18b6afd63374c1",8756: "c03c0cb12db8cbd2",9289: "26b5e99e47a48113",}[chunkId] + ".css"
}